"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _SelectedGoods = _interopRequireDefault(require("../SelectedGoods/SelectedGoods.vue"));
var _CouponProductsImport = _interopRequireDefault(require("@/components/CouponProductsImport"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _validate = require("@/utils/validate");
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var couponEnum = _interopRequireWildcard(require("../../../../enum"));
var _common = require("../../../common");
var _api = require("../../../api");
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi"));
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _dialog = _interopRequireDefault(require("@/libs/dialog"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var getCurrentAdminType = function getCurrentAdminType() {
  try {
    var javaInfo = _jsCookie.default.get('JavaInfo');
    return javaInfo ? Number(JSON.parse(javaInfo).type) : 0;
  } catch (error) {
    return 0;
  }
};
var _default = exports.default = {
  name: 'CouponAddorEdit',
  components: {
    ButtonUploadExcelVue: _ButtonUploadExcel.default,
    SelectGoodsVue: _SelectedGoods.default,
    CouponProductsImport: _CouponProductsImport.default,
    Tinymce: _index.default
  },
  data: function data() {
    var currentAdminType = getCurrentAdminType();
    return _objectSpread(_objectSpread({}, (0, _paginationEffect.default)(this.handlerGetListData)), {}, {
      couponRules: _common.couponRules,
      applicableProducts: [],
      showTableData: {
        list: [],
        total: 0
      },
      couponEnum: couponEnum,
      commonData: _common.commonData,
      timeFormat: _common.timeFormat,
      dateRangeDefaultTime: ['00:00:00', '23:59:59'],
      loading: false,
      loadingText: '提交中...',
      type: 'ADD',
      currentAdminType: currentAdminType,
      packageOptions: [],
      packageDialogVisible: false,
      currentPackageId: null,
      packageDetail: null,
      form: {
        marketingParty: currentAdminType === 4 ? 1 : 0,
        merchantId: null,
        couponType: 1,
        // 默认为满减券
        limitType: 1,
        // 默认为每人限领
        distributionCustomers: [],
        couponDiscount: [{}],
        cateIdList: [],
        applicableRangeType: null,
        packageIds: [],
        limitCount: 1,
        limitDailyCount: 1,
        internalRemark: '',
        usableScenarios: [],
        rangeConfig: null,
        applicableNotice: '',
        applicableScope: '',
        voucherType: 1,
        // 默认为优惠券
        selfOperatedCardVouchers: [],
        onlineOrderingBrands: [],
        verificationStoresMerchants: [],
        verificationStores: [],
        gasStationStores: [],
        renshouMerchants: [],
        renshouStores: [],
        enableCaptcha: 0,
        // 是否启用验证码，默认关闭
        enableParamEncryption: 0,
        // 是否启用领取参数加密，默认关闭
        enableStressTest: 0,
        // 是否启用压测模式，默认关闭
        enableRateLimit: 0,
        // 是否启用限流，默认关闭
        globalRateLimit: 100,
        // 全局限流，默认100次/秒
        userRateLimit: 5,
        // 用户级限流，默认5次/秒
        rateLimitWindowSeconds: 1,
        // 限流时间窗口，默认1秒
        excludeWelfareCard: 0,
        excludeWelfareCardIds: [],
        excludeOtherDiscounts: 0,
        polygonBoundary: '',
        // 多边形边界坐标点
        realNameAuthLimit: null,
        // 实名认证次数限制（仅在启用实名认证时生效）
        isIntegralExchange: 0,
        // 是否用于积分兑换（0:否 1:是）
        excludeNewcomerPrice: 1 // 是否与新人价互斥（0:否 1:是），新增默认是
      },
      packagePageData: {
        page: 1,
        limit: 10
      },
      packageTotal: 0,
      packageKeyword: '',
      packageLoading: false,
      voucherTypeOptions: [],
      // 券类型选项
      productTypeOptions: [],
      // 商品类型选项（可使用场景）
      addressData: [],
      // 省市区数据
      areaRestrictionScopeArray: [],
      // 地区限制范围数组（用于cascader显示，支持多选）
      areaRestrictionScopeList: [],
      // 存储所有已选择的地区完整路径（用于回显和显示）
      polygonBoundaryValidation: {
        // 多边形坐标点验证状态
        isValid: null,
        errorMessage: '',
        pointCount: 0
      },
      // 范围配置相关选项（需要根据实际业务接口补充）
      cardVoucherOptions: [],
      brandOptions: [],
      merchantOptions: [],
      storeOptions: [],
      gasStationOptions: [],
      gasStationLoading: false,
      gasStationKeyword: '',
      renshouMerchantOptions: [],
      renshouStoreOptions: [],
      welfareCardOptions: [],
      welfareCardLoading: false,
      // multi-step form state
      currentStep: 0,
      steps: ['基本信息', '其他信息', '范围配置', '使用说明']
    });
  },
  created: function created() {
    var id = this.$route.query.id;
    this.type = this.$route.path.split('/').pop();
    if (this.isMerchantAccount && !id) {
      this.applyMerchantCouponDefaults(true);
    }
    this.setTagsViewTitle(id);
    this.init({
      merchantMode: this.isMerchantAccount
    });
    if (!this.isMerchantAccount) {
      this.loadPackageOptions();
      this.loadVoucherTypeDict();
      this.loadAddressData();
      this.loadCardVoucherOptions();
      this.loadBrandOptions();
      this.loadMerchantOptions();
      this.loadStoreOptions();
      this.loadGasStationOptions();
      this.loadWelfareCardOptions();
    }
    this.loadProductTypeDict();
    this.loadRenshouMerchantOptions(); // 加载入驻商家列表（与核销门店商家共用）
    this.loadRenshouStoreOptions(); // 初始化时加载入驻商家门店（仅网店）
    if (id) {
      this.ID = id;
      this.getDetail(id);
    }
    console.log('created');
  },
  computed: {
    isMerchantAccount: function isMerchantAccount() {
      return this.currentAdminType === 4;
    },
    isMerchantCoupon: function isMerchantCoupon() {
      return Number(this.form.marketingParty) === 1;
    },
    // 复制生成的是尚未入库的新券，只有编辑已领取券时才锁定优惠规则和有效期
    isReceivedCouponLocked: function isReceivedCouponLocked() {
      return this.type === 'EDIT' && Number(this.form.receiveCount || 0) > 0;
    },
    availableProductTypeOptions: function availableProductTypeOptions() {
      if (!this.isMerchantCoupon) return this.productTypeOptions;
      return this.productTypeOptions.filter(function (item) {
        return [100, 101, 102].includes(Number(item.code));
      });
    },
    // 编辑模式下积分兑换券不可切换「是否用于积分兑换」
    isIntegralExchangeLocked: function isIntegralExchangeLocked() {
      return this.type === 'EDIT' && this.form.isIntegralExchange === 1;
    }
  },
  watch: {
    // 移除原来的watch，改为使用@change事件处理
  },
  methods: {
    init: _common.init,
    applyMerchantCouponDefaults: function applyMerchantCouponDefaults() {
      var resetSelections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.isMerchantCoupon) return;
      Object.assign(this.form, {
        marketingParty: 1,
        isIntegralExchange: 0,
        excludeNewcomerPrice: 1,
        voucherType: 1,
        isPublic: 1,
        redeemPageUrl: '',
        distributionCustomers: [],
        packageIds: [],
        requireRealNameAuth: 0,
        realNameAuthLimit: null,
        isAreaRestricted: 0,
        areaRestrictionScope: '',
        polygonBoundary: '',
        enableCaptcha: 0,
        enableParamEncryption: 0,
        enableStressTest: 0,
        enableRateLimit: 0,
        globalRateLimit: null,
        userRateLimit: null,
        rateLimitWindowSeconds: null,
        excludeWelfareCard: 0,
        excludeWelfareCardIds: [],
        excludeOtherDiscounts: 0,
        areaValidationFailMsg: '',
        applicableRangeType: 1,
        applicableProducts: '',
        cateIdList: [],
        selfOperatedCardVouchers: [],
        onlineOrderingBrands: [],
        verificationStoresMerchants: [],
        verificationStores: [],
        gasStationStores: []
      });
      var allowedScenarios = [100, 101, 102];
      var selectedScenarios = Array.isArray(this.form.usableScenarios) ? this.form.usableScenarios.map(Number).filter(function (item) {
        return allowedScenarios.includes(item);
      }) : [];
      if (resetSelections || selectedScenarios.length === 0) {
        this.form.usableScenarios = allowedScenarios;
      } else {
        this.form.usableScenarios = selectedScenarios;
      }
      if (this.isMerchantAccount) {
        if (this.renshouMerchantOptions.length) {
          this.form.renshouMerchants = this.renshouMerchantOptions.map(function (item) {
            return item.id;
          });
        } else if (resetSelections) {
          this.form.renshouMerchants = [];
        }
        if (resetSelections && this.renshouStoreOptions.length) {
          this.form.renshouStores = this.renshouStoreOptions.map(function (item) {
            return item.id;
          });
        } else if (resetSelections) {
          this.form.renshouStores = [];
        }
      }
    },
    handleUsableScenariosChange: function handleUsableScenariosChange(selected) {
      try {
        // selected 是当前选中的场景数组，1 表示普通商品（ProductTypeEnum.COMMON）
        var hasCommon = Array.isArray(selected) && selected.includes(1);
        if (!hasCommon) {
          // 清理与实物商品相关的配置，避免前端提交空数据给后端
          this.form.applicableRangeType = null;
          this.applicableProducts = [];
          this.updateTableData([]);
        }
      } catch (e) {
        console.error('处理可使用场景变更失败:', e);
      }
    },
    setTagsViewTitle: function setTagsViewTitle(id) {
      var route = {
        path: this.$route.path,
        title: this.type == 'ADD' ? '优惠券添加' : this.type === 'EDIT' ? "\u7F16\u8F91\u4F18\u60E0\u5238-".concat(id) : "\u590D\u5236\u4F18\u60E0\u5238-".concat(id)
      };
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    close: function close() {
      this.form = {
        distributionCustomers: [],
        couponDiscount: [{}]
      };
      this.$router.push({
        path: '/marketing/coupon/list'
      });
    },
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loadingText = '获取信息中...';
              this.loading = true;
              this.request(_api.detailCouponsApi, id, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return _this.handleInfo(res);
                      case 1:
                        _this.loading = false;
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    handleInfo: function () {
      var _handleInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
        var _distributionCustomer,
          _this2 = this;
        var _ref2, startTime, endTime, validityStart, validityEnd, distributionCustomers, applicableRangeType, productAttrValueList, packageIds, limitQuantity, limitType, parsedLimitQuantity, limitCount, limitDailyCount, areaData, parts, path;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref2 = res || {}, startTime = _ref2.startTime, endTime = _ref2.endTime, validityStart = _ref2.validityStart, validityEnd = _ref2.validityEnd, distributionCustomers = _ref2.distributionCustomers, applicableRangeType = _ref2.applicableRangeType, productAttrValueList = _ref2.productAttrValueList, packageIds = _ref2.packageIds, limitQuantity = _ref2.limitQuantity, limitType = _ref2.limitType; // 处理packageIds，确保是数组格式
              if (packageIds) {
                if (typeof packageIds === 'string' && packageIds.includes(',')) {
                  // 字符串格式的packageIds，可能是逗号分隔的ID列表
                  packageIds = packageIds.split(',').map(function (id) {
                    return parseInt(id.trim(), 10);
                  }).filter(Boolean);
                } else if (Array.isArray(packageIds)) {
                  // 已经是数组，确保每一项是数字
                  packageIds = packageIds.map(function (id) {
                    return typeof id === 'string' ? parseInt(id, 10) : id;
                  }).filter(Boolean);
                } else if (!Array.isArray(packageIds)) {
                  // 如果是单个数值，转换为数组
                  packageIds = [typeof packageIds === 'string' ? parseInt(packageIds, 10) : packageIds].filter(Boolean);
                }
              } else {
                // 没有packageIds，初始化为空数组
                packageIds = [];
              }

              // 处理限领数量
              parsedLimitQuantity = limitQuantity && parseInt(limitQuantity, 10) > 0 ? parseInt(limitQuantity, 10) : 1; // 确保limitType有效
              if (!limitType || limitType !== 1 && limitType !== 2) {
                limitType = 1; // 默认为"每人限领"
              }

              // 根据领用规则类型设置不同的限制数量
              limitCount = 1;
              limitDailyCount = 1;
              if (limitType === 1) {
                // 每人限领
                limitCount = parsedLimitQuantity;
                limitDailyCount = 1; // 默认值
              } else if (limitType === 2) {
                // 每人每天限领
                limitCount = 1; // 默认值
                limitDailyCount = parsedLimitQuantity;
              }

              // 如果是复制操作，确保领用规则相关字段都正确设置
              if (this.type === 'COPY') {
                console.log('复制优惠券，原始领用规则：', {
                  limitType: limitType,
                  limitQuantity: limitQuantity,
                  parsedLimitQuantity: parsedLimitQuantity,
                  limitCount: limitCount,
                  limitDailyCount: limitDailyCount
                });
              }
              this.form = _objectSpread(_objectSpread({}, res), {}, {
                marketingParty: this.type === 'COPY' ? this.isMerchantAccount ? 1 : 0 : Number(res.marketingParty) === 1 ? 1 : 0,
                merchantId: this.type === 'COPY' ? null : res.merchantId,
                receiveTime: startTime && endTime ? [startTime, endTime] : [],
                lifespanTime: validityStart && validityEnd ? [validityStart, validityEnd] : [],
                distributionCustomers: distributionCustomers === null || distributionCustomers === void 0 ? void 0 : (_distributionCustomer = distributionCustomers.split(',')) === null || _distributionCustomer === void 0 ? void 0 : _distributionCustomer.map(function (j) {
                  return Number(j);
                }),
                packageIds: Array.isArray(packageIds) ? packageIds : [],
                limitType: limitType,
                // 设置领用规则类型
                limitCount: limitCount,
                limitDailyCount: limitDailyCount,
                // 初始化消费券相关字段，如果没有则设置默认值
                voucherType: res.voucherType || 1,
                // 默认为优惠券
                requireRealNameAuth: res.requireRealNameAuth || 0,
                isAreaRestricted: res.isAreaRestricted || 0,
                enableCaptcha: res.enableCaptcha || 0,
                // 是否启用验证码
                enableRateLimit: res.enableRateLimit || 0,
                // 是否启用限流
                globalRateLimit: res.globalRateLimit || 100,
                // 全局限流
                userRateLimit: res.userRateLimit || 5,
                // 用户级限流
                rateLimitWindowSeconds: res.rateLimitWindowSeconds || 1,
                // 限流时间窗口
                areaRestrictionScope: res.areaRestrictionScope || '',
                excludeWelfareCard: res.excludeWelfareCard || 0,
                excludeWelfareCardIds: this.parseExcludeWelfareCardIds(res.excludeWelfareCardIds),
                excludeOtherDiscounts: res.excludeOtherDiscounts || 0,
                couponTag: res.couponTag || '',
                areaValidationFailMsg: res.areaValidationFailMsg || '',
                polygonBoundary: res.polygonBoundary || '',
                // 多边形边界坐标点
                isIntegralExchange: res.isIntegralExchange || 0,
                excludeNewcomerPrice: Number(res.excludeNewcomerPrice) === 1 ? 1 : 0,
                usableScenarios: res.usableScenarios ? JSON.parse(res.usableScenarios) : [],
                rangeConfig: res.rangeConfig ? JSON.parse(res.rangeConfig) : {},
                applicableNotice: res.applicableNotice || '',
                applicableScope: res.applicableScope || '',
                // 解析范围配置
                selfOperatedCardVouchers: res.rangeConfig && JSON.parse(res.rangeConfig).selfOperatedCardVouchers || [],
                onlineOrderingBrands: res.rangeConfig && JSON.parse(res.rangeConfig).onlineOrderingBrands || [],
                verificationStoresMerchants: res.rangeConfig && JSON.parse(res.rangeConfig).verificationStoresMerchants || [],
                verificationStores: res.rangeConfig && JSON.parse(res.rangeConfig).verificationStores || [],
                gasStationStores: res.rangeConfig && JSON.parse(res.rangeConfig).gasStationStores || [],
                renshouMerchants: res.rangeConfig && JSON.parse(res.rangeConfig).renshouMerchants || [],
                // 从 renshouMerchantsStores 读取（如果存在），否则从 renshouStores 读取（向后兼容）
                renshouStores: function () {
                  if (!res.rangeConfig) return [];
                  var config = JSON.parse(res.rangeConfig);
                  return config.renshouMerchantsStores || config.renshouStores || [];
                }()
              });

              // 处理地区限制范围回显（支持多选）
              if (res.areaRestrictionScope) {
                try {
                  areaData = JSON.parse(res.areaRestrictionScope); // 支持旧格式（单个地区对象）和新格式（地区数组）
                  if (Array.isArray(areaData)) {
                    // 新格式：数组格式，转换为cascader需要的路径格式
                    this.areaRestrictionScopeArray = areaData.map(function (area) {
                      // 构建完整路径数组，确保有3级
                      var path = [];
                      if (area.province) path.push(area.province);
                      if (area.city) path.push(area.city);
                      if (area.district) path.push(area.district);
                      // 如果路径少于3级，补充
                      while (path.length < 3 && path.length > 0) {
                        path.push(path[path.length - 1]);
                      }
                      return path;
                    });
                    this.areaRestrictionScopeList = areaData.map(function (area) {
                      var parts = [area.province, area.city, area.district].filter(Boolean);
                      return parts.join(' / ');
                    });
                    this.form.areaRestrictionScope = res.areaRestrictionScope;
                  } else if (areaData.province || areaData.city || areaData.district) {
                    // 旧格式：单个地区对象，转换为新格式
                    parts = [areaData.province, areaData.city, areaData.district].filter(Boolean); // 构建完整路径，确保有3级
                    path = _toConsumableArray(parts);
                    while (path.length < 3 && path.length > 0) {
                      path.push(path[path.length - 1]);
                    }
                    this.areaRestrictionScopeArray = [path];
                    this.areaRestrictionScopeList = parts.length > 0 ? [parts.join(' / ')] : [];
                    // 转换为新格式存储
                    this.form.areaRestrictionScope = JSON.stringify([areaData]);
                  } else {
                    this.form.areaRestrictionScope = '';
                    this.areaRestrictionScopeArray = [];
                    this.areaRestrictionScopeList = [];
                  }
                } catch (e) {
                  console.error('解析地区限制范围失败:', e);
                  this.form.areaRestrictionScope = '';
                  this.areaRestrictionScopeArray = [];
                  this.areaRestrictionScopeList = [];
                }
              } else {
                this.areaRestrictionScopeArray = [];
                this.areaRestrictionScopeList = [];
              }

              // 如果有多边形边界坐标点，验证格式
              if (res.polygonBoundary) {
                this.$nextTick(function () {
                  _this2.validatePolygonBoundary();
                });
              }
              if (this.isMerchantCoupon) {
                this.applyMerchantCouponDefaults(this.type === 'COPY');
              }

              // 如果有packageIds，加载这些包的详情
              if (!this.isMerchantCoupon && packageIds && packageIds.length > 0) {
                this.loadMissingPackages(packageIds);
              }

              // 回显仁寿商户和门店：如果有选中的商家，加载对应的门店列表
              if (!(this.form.renshouMerchants && this.form.renshouMerchants.length > 0)) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return this.loadRenshouStoreOptions(this.form.renshouMerchants);
            case 1:
              applicableRangeType !== 1 && this.updateTableData(productAttrValueList);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleInfo(_x3) {
        return _handleInfo.apply(this, arguments);
      }
      return handleInfo;
    }(),
    updateTableData: function updateTableData() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.applicableProducts = _toConsumableArray(list);
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var start = (this.pageData.page - 1) * this.pageData.limit;
      var end = start + this.pageData.limit;
      this.showTableData.list = this.applicableProducts.slice(start, end);
      this.$set(this.showTableData, 'total', this.applicableProducts.length);
    },
    goSelectGoods: function goSelectGoods() {
      this.$refs.selectGoodsVueRef.open({
        selectedList: this.applicableProducts,
        applicableRangeType: this.form.applicableRangeType
      });
    },
    changeCouponDiscountInfo: function changeCouponDiscountInfo(index) {
      if (index === 'add') {
        var newItem = {};
        if (this.form.couponType === 2) {
          newItem.thresholdType = 2;
        } else {
          newItem.thresholdType = 1;
        }
        this.form.couponDiscount.unshift(newItem);
      } else {
        this.form.couponDiscount.splice(index, 1);
      }
    },
    changeCouponType: function changeCouponType() {
      var thresholdType = this.form.couponType === 2 ? 2 : 1;
      this.$set(this.form, 'couponDiscount', [{}]);
      this.$set(this.form.couponDiscount[0], 'thresholdType', thresholdType);
    },
    changeApplicableRangeType: function changeApplicableRangeType() {
      this.applicableProducts = [];
      this.updateTableData();
    },
    removeGoods: function removeGoods(index) {
      this.applicableProducts.splice(index, 1);
      this.handlerGetListData();
    },
    validateDiscountRule: function validateDiscountRule(item, index) {
      // 校验折扣值范围（仅折扣券）
      if (this.form.couponType === 2) {
        if (item.discount < 0.1 || item.discount > 9.9) {
          this.$message.warning('折扣值必须在0.1-9.9之间');
          item.discount = undefined;
          return;
        }
      }
      // 校验当前规则的门槛值和折扣值是否填写
      var threshold = Number(item.threshold);
      var discount = Number(item.discount);
      if (!threshold || threshold <= 0) return;
      if (!discount || discount < 0) return;
      // 校验是否有冲突规则
      var discountList = this.form.couponDiscount || [];
      var thresholdType = item.thresholdType || 1;
      for (var i = 0; i < discountList.length; i++) {
        if (i === index) continue;
        var other = discountList[i];
        var otherThreshold = Number(other.threshold);
        var otherDiscount = Number(other.discount);
        var otherThresholdType = other.thresholdType || 1;
        if (!otherThreshold || otherThreshold <= 0 || !otherDiscount || otherDiscount < 0) continue;
        // 完全相同的规则
        if (threshold === otherThreshold && thresholdType === otherThresholdType && discount === otherDiscount) {
          this.$message.warning("\u7B2C".concat(index + 1, "\u6761\u4E0E\u7B2C").concat(i + 1, "\u6761\u4F18\u60E0\u89C4\u5219\u5B8C\u5168\u76F8\u540C\uFF0C\u5B58\u5728\u51B2\u7A81"));
          return;
        }
        // 门槛类型和门槛值相同，但折扣不同
        if (threshold === otherThreshold && thresholdType === otherThresholdType && discount !== otherDiscount) {
          this.$message.warning("\u7B2C".concat(index + 1, "\u6761\u4E0E\u7B2C").concat(i + 1, "\u6761\u4F18\u60E0\u89C4\u5219\u7684\u95E8\u69DB\u7C7B\u578B\u548C\u95E8\u69DB\u503C\u76F8\u540C\u4F46\u6298\u6263\u4E0D\u540C\uFF0C\u5B58\u5728\u51B2\u7A81"));
          return;
        }
      }
    },
    //  请求工具函数
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(api, params, callback) {
        var _this3 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              api(params).then(function (res) {
                callback(res);
                _this3.loading = false;
              }).catch(function (err) {
                _this3.loading = false;
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      function request(_x4, _x5, _x6) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    handleParams: function handleParams() {
      var _data$receiveTime, _data$lifespanTime, _data$distributionCus;
      if (this.isMerchantCoupon) {
        this.applyMerchantCouponDefaults(false);
      }
      var data = _objectSpread({}, this.form);
      if (data !== null && data !== void 0 && (_data$receiveTime = data.receiveTime) !== null && _data$receiveTime !== void 0 && _data$receiveTime.length) {
        data.startTime = data.receiveTime[0];
        data.endTime = data.receiveTime[1];
      }
      ;
      delete data.receiveTime;
      // 处理有效期时间格式
      if (data !== null && data !== void 0 && (_data$lifespanTime = data.lifespanTime) !== null && _data$lifespanTime !== void 0 && _data$lifespanTime.length) {
        data.validityEnd = data.lifespanTime[1];
        data.validityStart = data.lifespanTime[0];
      }
      ;
      delete data.lifespanTime;
      // 商品信息
      if ([2, 3].includes(data.applicableRangeType)) {
        var _this$applicableProdu, _this$applicableProdu2;
        data.applicableProducts = (_this$applicableProdu = this.applicableProducts) === null || _this$applicableProdu === void 0 ? void 0 : (_this$applicableProdu2 = _this$applicableProdu.map(function (item) {
          return item === null || item === void 0 ? void 0 : item.id;
        })) === null || _this$applicableProdu2 === void 0 ? void 0 : _this$applicableProdu2.join(',');
        data === null || data === void 0 ? true : delete data.cateIdList;
      } else if (data.applicableRangeType == 4) {
        // 展示分类
        data === null || data === void 0 ? true : delete data.applicableProducts;
      }
      ;
      data.distributionCustomers = data === null || data === void 0 ? void 0 : (_data$distributionCus = data.distributionCustomers) === null || _data$distributionCus === void 0 ? void 0 : _data$distributionCus.join(',');

      // 处理券包ID，确保是数组格式且每个元素都是数字类型
      if (data.packageIds) {
        if (Array.isArray(data.packageIds)) {
          // 已经是数组，确保每一项是数字
          data.packageIds = data.packageIds.map(function (id) {
            var numId = typeof id === 'string' ? parseInt(id, 10) : id;
            return isNaN(numId) ? null : numId;
          }).filter(Boolean);
        } else if (typeof data.packageIds === 'string' && data.packageIds.includes(',')) {
          // 字符串格式的packageIds，可能是逗号分隔的ID列表
          data.packageIds = data.packageIds.split(',').map(function (id) {
            var numId = parseInt(id.trim(), 10);
            return isNaN(numId) ? null : numId;
          }).filter(Boolean);
        } else {
          // 如果是单个值但不是数组，转换为数组
          var numId = typeof data.packageIds === 'string' ? parseInt(data.packageIds, 10) : data.packageIds;
          data.packageIds = isNaN(numId) ? [] : [numId];
        }
      } else {
        // 如果没有选择，设置为空数组
        data.packageIds = [];
      }

      // 处理限领数量
      if (data.limitType === 1) {
        // 每人限领
        data.limitQuantity = data.limitCount;
      } else if (data.limitType === 2) {
        // 每人每天限领
        data.limitQuantity = data.limitDailyCount;
      } else {
        // 默认情况
        data.limitQuantity = data.limitCount || 1;
      }
      console.log('提交数据，领用规则：', {
        limitType: data.limitType,
        limitQuantity: data.limitQuantity,
        limitCount: data.limitCount,
        limitDailyCount: data.limitDailyCount
      });

      // 设置默认值
      if (!data.voucherType) {
        data.voucherType = 1; // 默认为优惠券
      }
      data.excludeNewcomerPrice = Number(data.excludeNewcomerPrice) === 1 ? 1 : 0;
      if (data.requireRealNameAuth === undefined || data.requireRealNameAuth === null) {
        data.requireRealNameAuth = 0;
      }
      if (data.isAreaRestricted === undefined || data.isAreaRestricted === null) {
        data.isAreaRestricted = 0;
      }
      if (data.enableCaptcha === undefined || data.enableCaptcha === null) {
        data.enableCaptcha = 0;
      }
      // 处理限流配置
      if (data.enableRateLimit === undefined || data.enableRateLimit === null) {
        data.enableRateLimit = 0;
      }
      if (data.enableRateLimit === 0) {
        // 如果未启用限流，清空限流参数
        data.globalRateLimit = null;
        data.userRateLimit = null;
        data.rateLimitWindowSeconds = null;
      } else {
        // 如果启用限流，设置默认值
        if (data.globalRateLimit === undefined || data.globalRateLimit === null || data.globalRateLimit < 1) {
          data.globalRateLimit = 100;
        }
        if (data.userRateLimit === undefined || data.userRateLimit === null || data.userRateLimit < 1) {
          data.userRateLimit = 5;
        }
        if (data.rateLimitWindowSeconds === undefined || data.rateLimitWindowSeconds === null || data.rateLimitWindowSeconds < 1) {
          data.rateLimitWindowSeconds = 1;
        }
      }
      if (data.excludeWelfareCard === undefined || data.excludeWelfareCard === null) {
        data.excludeWelfareCard = 0;
      }
      if (data.excludeWelfareCard !== 1) {
        data.excludeWelfareCardIds = '';
      } else if (Array.isArray(data.excludeWelfareCardIds) && data.excludeWelfareCardIds.length > 0) {
        data.excludeWelfareCardIds = data.excludeWelfareCardIds.join(',');
      } else {
        data.excludeWelfareCardIds = '';
      }
      if (data.excludeOtherDiscounts === undefined || data.excludeOtherDiscounts === null) {
        data.excludeOtherDiscounts = 0;
      }
      // 处理实名认证次数限制：仅在启用实名认证时提交，否则清理该字段
      if (data.requireRealNameAuth === 1) {
        if (data.realNameAuthLimit !== undefined && data.realNameAuthLimit !== null) {
          data.realNameAuthLimit = parseInt(data.realNameAuthLimit, 10) || null;
        } else {
          data.realNameAuthLimit = null;
        }
      } else {
        delete data.realNameAuthLimit;
      }

      // 处理可使用场景：数组转JSON字符串
      if (data.usableScenarios && Array.isArray(data.usableScenarios)) {
        data.usableScenarios = JSON.stringify(data.usableScenarios);
      } else if (!data.usableScenarios) {
        data.usableScenarios = JSON.stringify([]);
      }

      // 如果未选择普通商品（1 对应普通商品），前端不应该提交实物商品相关配置
      try {
        var usableArr = JSON.parse(data.usableScenarios || '[]');
        var hasCommon = Array.isArray(usableArr) && usableArr.includes(1);
        if (!hasCommon) {
          // 清理实物商品相关字段，避免后台接收到空串或错误数据
          delete data.applicableRangeType;
          delete data.applicableProducts;
          delete data.cateIdList;
        }
      } catch (e) {
        // 忽略解析异常，后端会做二次校验
        console.error('解析 usableScenarios 失败', e);
      }

      // 处理范围配置：对象转JSON字符串
      var rangeConfig = {
        selfOperatedCardVouchers: data.selfOperatedCardVouchers || [],
        onlineOrderingBrands: data.onlineOrderingBrands || [],
        verificationStoresMerchants: data.verificationStoresMerchants || [],
        verificationStores: data.verificationStores || [],
        gasStationStores: data.gasStationStores || [],
        renshouMerchants: data.renshouMerchants || [],
        // 将 renshouStores 映射为 renshouMerchantsStores 存储（避免重复）
        renshouMerchantsStores: data.renshouStores || []
      };
      data.rangeConfig = JSON.stringify(rangeConfig);

      // 清理临时字段（不在后端实体中的字段）
      delete data.selfOperatedCardVouchers;
      delete data.onlineOrderingBrands;
      delete data.verificationStoresMerchants;
      delete data.verificationStores;
      delete data.gasStationStores;
      delete data.renshouMerchants;
      delete data.renshouStores;
      return data;
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this4 = this;
        var discountList, i, j, a, b, thresholdA, thresholdB, discountA, discountB, thresholdTypeA, thresholdTypeB, valid;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              // 允许在任意步骤提交，校验整个表单后提交
              // 额外校验：检查优惠规则是否有冲突（threshold + thresholdType 相同，或完全相同的规则）
              discountList = this.form.couponDiscount || [];
              i = 0;
            case 1:
              if (!(i < discountList.length)) {
                _context5.n = 6;
                break;
              }
              j = i + 1;
            case 2:
              if (!(j < discountList.length)) {
                _context5.n = 5;
                break;
              }
              a = discountList[i];
              b = discountList[j];
              thresholdA = Number(a.threshold) || 0;
              thresholdB = Number(b.threshold) || 0;
              discountA = Number(a.discount) || 0;
              discountB = Number(b.discount) || 0;
              thresholdTypeA = a.thresholdType || 1;
              thresholdTypeB = b.thresholdType || 1;
              if (!(thresholdA === thresholdB && thresholdTypeA === thresholdTypeB && discountA === discountB)) {
                _context5.n = 3;
                break;
              }
              this.$message.warning("\u7B2C".concat(i + 1, "\u6761\u548C\u7B2C").concat(j + 1, "\u6761\u4F18\u60E0\u89C4\u5219\u5B8C\u5168\u76F8\u540C\uFF0C\u5B58\u5728\u51B2\u7A81\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5"));
              return _context5.a(2);
            case 3:
              if (!(thresholdA === thresholdB && thresholdTypeA === thresholdTypeB)) {
                _context5.n = 4;
                break;
              }
              this.$message.warning("\u7B2C".concat(i + 1, "\u6761\u548C\u7B2C").concat(j + 1, "\u6761\u4F18\u60E0\u89C4\u5219\u7684\u95E8\u69DB\u7C7B\u578B\u76F8\u540C\u4E14\u95E8\u69DB\u503C\u76F8\u540C\uFF0C\u5B58\u5728\u51B2\u7A81\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u8BD5"));
              return _context5.a(2);
            case 4:
              j++;
              _context5.n = 2;
              break;
            case 5:
              i++;
              _context5.n = 1;
              break;
            case 6:
              _context5.n = 7;
              return this.$refs.formRef.validate();
            case 7:
              valid = _context5.v;
              if (valid) {
                _context5.n = 8;
                break;
              }
              this.$message.warning('请填写完整信息');
              return _context5.a(2);
            case 8:
              if (!(this.form.requireRealNameAuth === 1)) {
                _context5.n = 10;
                break;
              }
              if (!(!this.form.realNameAuthLimit || Number(this.form.realNameAuthLimit) < 1)) {
                _context5.n = 9;
                break;
              }
              this.$message.warning('启用实名认证时，请填写有效的实名认证次数限制（>=1）');
              return _context5.a(2);
            case 9:
              // 确保为整数
              this.form.realNameAuthLimit = Math.floor(Number(this.form.realNameAuthLimit));
            case 10:
              // 显示确认对话框
              this.$confirm('一旦操作成功，活动/功能将会生效并在前端露出，确认提交?', '提示', {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                // 用户确认提交
                _this4.loadingText = '提交中...';
                _this4.loading = true;
                var params = _this4.handleParams();
                console.log(params);
                console.log(_this4.type);
                if (_this4.type === 'COPY') {
                  delete params.id;
                  delete params.receiveCount;
                  delete params.isDeleted;
                  delete params.status;
                  delete params.closeReason;
                  delete params.createTime;
                  delete params.updateTime;
                  delete params.createdBy;
                  delete params.updatedBy;
                  _this4.add(params);
                } else if (_this4.type === 'EDIT') {
                  _this4.update(params);
                } else {
                  _this4.add(params);
                }
              }).catch(function () {
                // 用户取消提交
                _this4.$message.info('已取消提交');
              });
            case 11:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    add: function add(params) {
      var _this5 = this;
      this.request(_api.createCouponsApi, params, function () {
        _this5.loading = false;
        _this5.$emit('refresh');
        _this5.close();
        _this5.$message.success('添加成功！');
      });
    },
    update: function update(params) {
      var _this6 = this;
      this.request(_api.updateCouponsApi, params, function () {
        _this6.loading = false;
        _this6.$emit('refresh');
        _this6.close();
        _this6.$message.success('修改成功！');
      });
    },
    nextStep: function nextStep() {
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        // scroll to top of form for better UX
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    prevStep: function prevStep() {
      if (this.currentStep > 0) {
        this.currentStep -= 1;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    handleImportSuccess: function handleImportSuccess(importedProducts) {
      if (importedProducts && importedProducts.length > 0) {
        this.applicableProducts = [].concat(_toConsumableArray(this.applicableProducts), _toConsumableArray(importedProducts));
        this.handlerGetListData();
      }
    },
    loadVoucherTypeDict: function () {
      var _loadVoucherTypeDict = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res, _t;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return (0, _api.getVoucherTypeDictApi)();
            case 1:
              res = _context6.v;
              this.voucherTypeOptions = res || [];
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t = _context6.v;
              console.error('加载券类型字典失败:', _t);
              this.voucherTypeOptions = [];
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function loadVoucherTypeDict() {
        return _loadVoucherTypeDict.apply(this, arguments);
      }
      return loadVoucherTypeDict;
    }(),
    handleAreaRestrictedChange: function handleAreaRestrictedChange(value) {
      // 当取消地区限制时，清空地区限制范围和多边形坐标
      if (value === 0) {
        this.form.areaRestrictionScope = '';
        this.areaRestrictionScopeArray = [];
        this.areaRestrictionScopeList = [];
        this.form.polygonBoundary = '';
        this.polygonBoundaryValidation = {
          isValid: null,
          errorMessage: '',
          pointCount: 0
        };
      }
    },
    handleRateLimitChange: function handleRateLimitChange(value) {
      // 当取消限流时，重置为默认值
      if (value === 0) {
        this.form.globalRateLimit = 100;
        this.form.userRateLimit = 5;
        this.form.rateLimitWindowSeconds = 1;
      }
    },
    handleAreaChange: function handleAreaChange(value) {
      // 处理多选地区选择变化
      // value是二维数组，每个元素是一个完整的路径数组，如：[['北京', '北京', '海淀区'], ['上海', '上海', '黄浦区']]
      if (value && value.length > 0) {
        try {
          var areaList = [];
          var displayList = [];
          value.forEach(function (path) {
            // path是完整路径数组，如：['北京', '北京', '海淀区']
            // 如果只有2级，则district用city的值；如果只有1级，则city和district都用province的值
            var province = path[0] || '';
            var city = path[1] || path[0] || '';
            var district = path[2] || path[1] || path[0] || '';
            areaList.push({
              province: province,
              city: city,
              district: district
            });

            // 构建显示路径，过滤空值
            var displayPath = path.filter(Boolean).join(' / ');
            displayList.push(displayPath);
          });
          this.areaRestrictionScopeList = displayList;
          this.form.areaRestrictionScope = JSON.stringify(areaList);
        } catch (e) {
          console.error('地区信息转换失败:', e);
          this.form.areaRestrictionScope = '';
          this.areaRestrictionScopeList = [];
        }
      } else {
        this.form.areaRestrictionScope = '';
        this.areaRestrictionScopeList = [];
      }
    },
    // 验证多边形边界坐标点格式
    validatePolygonBoundary: function validatePolygonBoundary() {
      var value = this.form.polygonBoundary;

      // 如果为空，重置验证状态
      if (!value || value.trim() === '') {
        this.polygonBoundaryValidation = {
          isValid: null,
          errorMessage: '',
          pointCount: 0
        };
        return;
      }
      try {
        // 解析JSON
        var polygon = JSON.parse(value);

        // 检查是否为数组
        if (!Array.isArray(polygon)) {
          this.polygonBoundaryValidation = {
            isValid: false,
            errorMessage: '坐标点必须是数组格式',
            pointCount: 0
          };
          return;
        }

        // 检查至少3个点
        if (polygon.length < 3) {
          this.polygonBoundaryValidation = {
            isValid: false,
            errorMessage: '多边形至少需要3个坐标点',
            pointCount: polygon.length
          };
          return;
        }

        // 验证每个坐标点
        for (var i = 0; i < polygon.length; i++) {
          var point = polygon[i];

          // 检查是否为数组
          if (!Array.isArray(point)) {
            this.polygonBoundaryValidation = {
              isValid: false,
              errorMessage: "\u7B2C ".concat(i + 1, " \u4E2A\u5750\u6807\u70B9\u5FC5\u987B\u662F\u6570\u7EC4\u683C\u5F0F"),
              pointCount: polygon.length
            };
            return;
          }

          // 检查是否包含2个元素
          if (point.length !== 2) {
            this.polygonBoundaryValidation = {
              isValid: false,
              errorMessage: "\u7B2C ".concat(i + 1, " \u4E2A\u5750\u6807\u70B9\u5FC5\u987B\u5305\u542B2\u4E2A\u5143\u7D20\uFF08\u7ECF\u5EA6\u548C\u7EAC\u5EA6\uFF09"),
              pointCount: polygon.length
            };
            return;
          }

          // 检查是否为数字
          var longitude = Number(point[0]);
          var latitude = Number(point[1]);
          if (isNaN(longitude) || isNaN(latitude)) {
            this.polygonBoundaryValidation = {
              isValid: false,
              errorMessage: "\u7B2C ".concat(i + 1, " \u4E2A\u5750\u6807\u70B9\u7684\u503C\u5FC5\u987B\u662F\u6570\u5B57"),
              pointCount: polygon.length
            };
            return;
          }

          // 检查经纬度范围
          if (longitude < -180 || longitude > 180) {
            this.polygonBoundaryValidation = {
              isValid: false,
              errorMessage: "\u7B2C ".concat(i + 1, " \u4E2A\u5750\u6807\u70B9\u7684\u7ECF\u5EA6\u8D85\u51FA\u8303\u56F4\uFF08-180~180\uFF09"),
              pointCount: polygon.length
            };
            return;
          }
          if (latitude < -90 || latitude > 90) {
            this.polygonBoundaryValidation = {
              isValid: false,
              errorMessage: "\u7B2C ".concat(i + 1, " \u4E2A\u5750\u6807\u70B9\u7684\u7EAC\u5EA6\u8D85\u51FA\u8303\u56F4\uFF08-90~90\uFF09"),
              pointCount: polygon.length
            };
            return;
          }
        }

        // 验证通过
        this.polygonBoundaryValidation = {
          isValid: true,
          errorMessage: '',
          pointCount: polygon.length
        };

        // 格式化JSON（美化输出）
        this.form.polygonBoundary = JSON.stringify(polygon, null, 2);
      } catch (e) {
        this.polygonBoundaryValidation = {
          isValid: false,
          errorMessage: 'JSON格式错误：' + e.message,
          pointCount: 0
        };
      }
    },
    // 移除选中的地区
    removeArea: function removeArea(index) {
      this.areaRestrictionScopeArray.splice(index, 1);
      this.areaRestrictionScopeList.splice(index, 1);
      // 重新构建JSON数据
      if (this.areaRestrictionScopeArray.length > 0) {
        var areaList = this.areaRestrictionScopeArray.map(function (path) {
          var province = path[0] || '';
          var city = path[1] || path[0] || '';
          var district = path[2] || path[1] || path[0] || '';
          return {
            province: province,
            city: city,
            district: district
          };
        });
        this.form.areaRestrictionScope = JSON.stringify(areaList);
      } else {
        this.form.areaRestrictionScope = '';
        this.areaRestrictionScopeArray = [];
        this.areaRestrictionScopeList = [];
      }
    },
    handleIsPointsExchangeChange: function handleIsPointsExchangeChange(val) {
      var _this7 = this;
      if (val === 1) {
        // 固定券类型为优惠券（voucherType=1）
        this.$set(this.form, 'voucherType', 1);
        // 固定优惠方式为满减（couponType=1），并重置优惠信息
        if (this.form.couponType !== 1) {
          this.$set(this.form, 'couponType', 1);
          this.$set(this.form, 'couponDiscount', [{
            thresholdType: 1
          }]);
        }
        // 默认选择全部分销客户
        if (this.commonData.distributionCustomers && this.commonData.distributionCustomers.length > 0) {
          this.$set(this.form, 'distributionCustomers', this.commonData.distributionCustomers.map(function (item) {
            return item.id;
          }));
        }
        // 清除隐藏字段的校验状态
        this.$nextTick(function () {
          if (_this7.$refs.formRef) {
            _this7.$refs.formRef.clearValidate(['receiveTime', 'limitType', 'isPublic']);
          }
        });
      }
    },
    handleExcludeWelfareCardChange: function handleExcludeWelfareCardChange(value) {
      if (value !== 1) {
        this.form.excludeWelfareCardIds = [];
      }
    },
    loadWelfareCardOptions: function () {
      var _loadWelfareCardOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var keyword,
          res,
          _args7 = arguments,
          _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              keyword = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
              if (!(!keyword && this.welfareCardOptions.length > 0)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              this.welfareCardLoading = true;
              _context7.p = 2;
              _context7.n = 3;
              return fudouActiveApi.selectCard(keyword);
            case 3:
              res = _context7.v;
              this.welfareCardOptions = (res || []).map(function (item) {
                return {
                  value: item.id,
                  label: item.card_name
                };
              });
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('获取福卡列表失败:', _t2);
            case 5:
              _context7.p = 5;
              this.welfareCardLoading = false;
              return _context7.f(5);
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 4, 5, 6]]);
      }));
      function loadWelfareCardOptions() {
        return _loadWelfareCardOptions.apply(this, arguments);
      }
      return loadWelfareCardOptions;
    }(),
    parseExcludeWelfareCardIds: function parseExcludeWelfareCardIds(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return Number(item);
        }).filter(function (item) {
          return !isNaN(item);
        });
      }
      if (typeof value === 'string') {
        return value.split(',').map(function (item) {
          return Number(item.trim());
        }).filter(function (item) {
          return !isNaN(item);
        });
      }
      return [];
    },
    loadProductTypeDict: function () {
      var _loadProductTypeDict = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, _t3;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return (0, _api.getProductTypeDictApi)();
            case 1:
              res = _context8.v;
              this.productTypeOptions = res || [];
              if (this.isMerchantCoupon && (!Array.isArray(this.form.usableScenarios) || this.form.usableScenarios.length === 0)) {
                this.form.usableScenarios = this.availableProductTypeOptions.map(function (item) {
                  return Number(item.code);
                });
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t3 = _context8.v;
              console.error('加载商品类型字典失败:', _t3);
              this.productTypeOptions = [];
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function loadProductTypeDict() {
        return _loadProductTypeDict.apply(this, arguments);
      }
      return loadProductTypeDict;
    }(),
    loadAddressData: function loadAddressData() {
      var _this8 = this;
      logistics.treeLevel3ForSichuan().then(function (res) {
        _this8.addressData = res || [];
      }).catch(function (err) {
        console.error('加载地区数据失败:', err);
        _this8.addressData = [];
      });
    },
    loadCardVoucherOptions: function () {
      var _loadCardVoucherOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _api.getSelfOperatedCardProductsApi)();
            case 1:
              res = _context9.v;
              this.cardVoucherOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t4 = _context9.v;
              console.error('加载自营卡商品失败:', _t4);
              this.cardVoucherOptions = [];
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function loadCardVoucherOptions() {
        return _loadCardVoucherOptions.apply(this, arguments);
      }
      return loadCardVoucherOptions;
    }(),
    loadBrandOptions: function () {
      var _loadBrandOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res, _t5;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return (0, _api.getMealBrandsApi)();
            case 1:
              res = _context0.v;
              this.brandOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t5 = _context0.v;
              console.error('加载在线点餐品牌失败:', _t5);
              this.brandOptions = [];
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function loadBrandOptions() {
        return _loadBrandOptions.apply(this, arguments);
      }
      return loadBrandOptions;
    }(),
    loadMerchantOptions: function () {
      var _loadMerchantOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var res, _t6;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return (0, _api.getVerificationMerchantsApi)();
            case 1:
              res = _context1.v;
              this.merchantOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t6 = _context1.v;
              console.error('加载核销商家失败:', _t6);
              this.merchantOptions = [];
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function loadMerchantOptions() {
        return _loadMerchantOptions.apply(this, arguments);
      }
      return loadMerchantOptions;
    }(),
    loadRenshouMerchantOptions: function () {
      var _loadRenshouMerchantOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var res, _t7;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              _context10.n = 1;
              return (0, _api.getRenshouMerchantsApi)();
            case 1:
              res = _context10.v;
              this.renshouMerchantOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              if (!(this.isMerchantAccount && this.isMerchantCoupon)) {
                _context10.n = 2;
                break;
              }
              this.form.renshouMerchants = this.renshouMerchantOptions.map(function (item) {
                return item.id;
              });
              _context10.n = 2;
              return this.loadRenshouStoreOptions(this.form.renshouMerchants);
            case 2:
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t7 = _context10.v;
              console.error('加载仁寿网店商家失败:', _t7);
              this.renshouMerchantOptions = [];
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this, [[0, 3]]);
      }));
      function loadRenshouMerchantOptions() {
        return _loadRenshouMerchantOptions.apply(this, arguments);
      }
      return loadRenshouMerchantOptions;
    }(),
    loadStoreOptions: function () {
      var _loadStoreOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(merchantIds) {
        var params, res, _t8;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              params = {};
              if (merchantIds && merchantIds.length > 0) {
                // 支持批量商家ID查询
                params.merchantIds = merchantIds.join(',');
              }
              _context11.n = 1;
              return (0, _api.getVerificationStoresApi)(params);
            case 1:
              res = _context11.v;
              this.storeOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              _context11.n = 3;
              break;
            case 2:
              _context11.p = 2;
              _t8 = _context11.v;
              console.error('加载核销门店失败:', _t8);
              this.storeOptions = [];
            case 3:
              return _context11.a(2);
          }
        }, _callee11, this, [[0, 2]]);
      }));
      function loadStoreOptions(_x7) {
        return _loadStoreOptions.apply(this, arguments);
      }
      return loadStoreOptions;
    }(),
    loadRenshouStoreOptions: function () {
      var _loadRenshouStoreOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(merchantIds) {
        var params, res, _t9;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              params = {};
              if (merchantIds && merchantIds.length > 0) {
                // 支持批量商家ID查询
                params.merchantIds = merchantIds.join(',');
              }
              _context12.n = 1;
              return (0, _api.getRenshouStoresApi)(params);
            case 1:
              res = _context12.v;
              this.renshouStoreOptions = (res || []).map(function (item) {
                return {
                  id: item.key,
                  name: item.value
                };
              });
              if (this.isMerchantAccount && this.isMerchantCoupon && ['ADD', 'COPY'].includes(this.type)) {
                this.form.renshouStores = this.renshouStoreOptions.map(function (item) {
                  return item.id;
                });
              }
              _context12.n = 3;
              break;
            case 2:
              _context12.p = 2;
              _t9 = _context12.v;
              console.error('加载入驻商家门店失败:', _t9);
              this.renshouStoreOptions = [];
            case 3:
              return _context12.a(2);
          }
        }, _callee12, this, [[0, 2]]);
      }));
      function loadRenshouStoreOptions(_x8) {
        return _loadRenshouStoreOptions.apply(this, arguments);
      }
      return loadRenshouStoreOptions;
    }(),
    // 加载加油门店选项（使用智慧油客接口）
    loadGasStationOptions: function () {
      var _loadGasStationOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var keyword,
          res,
          _args13 = arguments,
          _t0;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              keyword = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : '';
              _context13.p = 1;
              this.gasStationLoading = true;
              _context13.n = 2;
              return (0, _api.getStationListApi)(keyword);
            case 2:
              res = _context13.v;
              // 后端返回的是 {id: stationCode, name: stationName} 格式
              this.gasStationOptions = (res || []).map(function (item) {
                return {
                  id: item.id || item.key,
                  // stationCode 作为 id（兼容两种格式）
                  name: item.name || item.value // stationName 作为显示名称（兼容两种格式）
                };
              });
              _context13.n = 4;
              break;
            case 3:
              _context13.p = 3;
              _t0 = _context13.v;
              console.error('加载加油门店失败:', _t0);
              this.gasStationOptions = [];
              this.$message.error('加载加油门店失败，请重试');
            case 4:
              _context13.p = 4;
              this.gasStationLoading = false;
              return _context13.f(4);
            case 5:
              return _context13.a(2);
          }
        }, _callee13, this, [[1, 3, 4, 5]]);
      }));
      function loadGasStationOptions() {
        return _loadGasStationOptions.apply(this, arguments);
      }
      return loadGasStationOptions;
    }(),
    // 处理加油门店搜索
    handleGasStationSearch: (0, _validate.Debounce)(function (query) {
      this.gasStationKeyword = query || '';
      this.loadGasStationOptions(query || '');
    }, 300),
    // 处理核销门店商家选择变化
    handleVerificationMerchantsChange: function () {
      var _handleVerificationMerchantsChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(selectedMerchantIds) {
        var allStoreIds, previousSelected, newSelected;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!(!selectedMerchantIds || selectedMerchantIds.length === 0)) {
                _context14.n = 1;
                break;
              }
              // 如果没有选择商家，清空门店选择并加载所有门店
              this.form.verificationStores = [];
              this.loadStoreOptions();
              return _context14.a(2);
            case 1:
              _context14.n = 2;
              return this.loadStoreOptions(selectedMerchantIds);
            case 2:
              // 自动选中该商家下的所有门店
              allStoreIds = this.storeOptions.map(function (store) {
                return store.id;
              }); // 保留之前已选中的门店（如果不在当前商家下，则保留）
              previousSelected = this.form.verificationStores || [];
              newSelected = _toConsumableArray(new Set([].concat(_toConsumableArray(previousSelected), _toConsumableArray(allStoreIds))));
              this.form.verificationStores = newSelected;
            case 3:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function handleVerificationMerchantsChange(_x9) {
        return _handleVerificationMerchantsChange.apply(this, arguments);
      }
      return handleVerificationMerchantsChange;
    }(),
    // 处理入驻商家选择变化
    handleRenshouMerchantsChange: function () {
      var _handleRenshouMerchantsChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(selectedMerchantIds) {
        var allStoreIds, previousSelected, newSelected;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              if (!(!selectedMerchantIds || selectedMerchantIds.length === 0)) {
                _context15.n = 1;
                break;
              }
              // 如果没有选择商家，清空门店选择并加载所有网店门店
              this.form.renshouStores = [];
              this.loadRenshouStoreOptions();
              return _context15.a(2);
            case 1:
              _context15.n = 2;
              return this.loadRenshouStoreOptions(selectedMerchantIds);
            case 2:
              // 自动选中该商家下的所有门店（仅网店）
              allStoreIds = this.renshouStoreOptions.map(function (store) {
                return store.id;
              }); // 保留之前已选中的门店（如果不在当前商家下，则保留）
              previousSelected = this.form.renshouStores || [];
              newSelected = _toConsumableArray(new Set([].concat(_toConsumableArray(previousSelected), _toConsumableArray(allStoreIds))));
              this.form.renshouStores = newSelected;
            case 3:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function handleRenshouMerchantsChange(_x0) {
        return _handleRenshouMerchantsChange.apply(this, arguments);
      }
      return handleRenshouMerchantsChange;
    }(),
    loadPackageOptions: function loadPackageOptions() {
      var _this9 = this;
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (refresh) {
        this.packagePageData.page = 1;
        this.packageOptions = [];
      }
      this.packageLoading = true;
      var params = {
        page: this.packagePageData.page,
        limit: this.packagePageData.limit,
        packageName: this.packageKeyword
      };
      (0, _api.couponPackageListApi)(params).then(function (res) {
        var _ref3 = res || {
            list: [],
            total: 0
          },
          list = _ref3.list,
          total = _ref3.total;

        // Process list to ensure consistent property names
        var processedList = (list || []).map(function (item) {
          return {
            id: item.id,
            name: item.packageName || item.name,
            description: item.description,
            couponCount: item.couponCount || 0
          };
        });
        if (refresh) {
          _this9.packageOptions = processedList;
        } else {
          _this9.packageOptions = [].concat(_toConsumableArray(_this9.packageOptions), _toConsumableArray(processedList));
        }
        _this9.packageTotal = total;
        _this9.packageLoading = false;

        // If there are any selected packageIds, make sure we load their details
        if (_this9.form.packageIds && _this9.form.packageIds.length > 0) {
          _this9.loadMissingPackages(_this9.form.packageIds);
        }
      }).catch(function (err) {
        console.error('Failed to load package options:', err);
        _this9.packageOptions = [];
        _this9.packageTotal = 0;
        _this9.packageLoading = false;
        _this9.$message.error('加载券包失败，请重试');
      });
    },
    loadMissingPackages: function loadMissingPackages(packageIds) {
      var _this0 = this;
      if (!packageIds || !packageIds.length) return;
      var missingIds = packageIds.filter(function (id) {
        return !_this0.packageOptions.some(function (option) {
          return option.id == id;
        });
      });
      if (missingIds.length === 0) return;

      // For each missing ID, try to load details
      Promise.all(missingIds.map(function (id) {
        return _this0.getPackageById(id);
      })).then(function (packages) {
        var validPackages = packages.filter(Boolean);
        if (validPackages.length) {
          _this0.packageOptions = [].concat(_toConsumableArray(_this0.packageOptions), _toConsumableArray(validPackages));
        }
      });
    },
    getPackageById: function getPackageById(id) {
      return new Promise(function (resolve, reject) {
        (0, _api.couponPackageDetailApi)(id).then(function (res) {
          if (res) {
            var _res$coupons;
            var packageItem = {
              id: res.id,
              name: res.packageName || res.name || "\u5238\u5305".concat(id),
              description: res.description,
              couponCount: ((_res$coupons = res.coupons) === null || _res$coupons === void 0 ? void 0 : _res$coupons.length) || 0
            };
            resolve(packageItem);
          } else {
            reject('返回数据为空');
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    handlePackageSearch: function handlePackageSearch(query) {
      this.packageKeyword = query;
      this.throttleSearch(query);
    },
    throttleSearch: (0, _validate.Debounce)(function (query) {
      this.loadPackageOptions(true);
    }, 300),
    loadMorePackages: function loadMorePackages() {
      this.packagePageData.page += 1;
      this.loadPackageOptions(false);
    },
    viewPackageDetails: function viewPackageDetails() {
      var _this1 = this;
      if (!this.form.packageIds || this.form.packageIds.length === 0) return;

      // Find selected packages
      var selectedPackages = this.packageOptions.filter(function (item) {
        return _this1.form.packageIds.includes(item.id);
      });
      if (selectedPackages.length > 0) {
        var packageDetails = '<div style="text-align: left;">';
        packageDetails += "<h3>\u5DF2\u9009\u4E2D\u7684\u5238\u5305\uFF08".concat(selectedPackages.length, "\u4E2A\uFF09</h3>");
        selectedPackages.forEach(function (pkg, index) {
          packageDetails += "\n            <div style=\"margin-top: 10px; padding-bottom: 10px; ".concat(index < selectedPackages.length - 1 ? 'border-bottom: 1px solid #EBEEF5;' : '', "\">\n              <p><strong>").concat(index + 1, ". ").concat(pkg.name, "</strong></p>\n              <p style=\"color: #606266; font-size: 13px;\">\u63CF\u8FF0\uFF1A").concat(pkg.description || '无', "</p>\n              <p style=\"color: #606266; font-size: 13px;\">\u4F18\u60E0\u5238\u6570\u91CF\uFF1A").concat(pkg.couponCount, "\u5F20</p>\n            </div>\n          ");
        });
        packageDetails += '</div>';
        this.$alert(packageDetails, '已选券包详情', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定'
        });
      }
    },
    // 全选适用分销客户
    selectAllCustomers: function selectAllCustomers() {
      if (this.commonData.distributionCustomers && this.commonData.distributionCustomers.length > 0) {
        this.form.distributionCustomers = this.commonData.distributionCustomers.map(function (item) {
          return item.id;
        });
        this.$message.success("\u5DF2\u5168\u9009 ".concat(this.form.distributionCustomers.length, " \u4E2A\u5BA2\u6237"));
      }
    },
    // 清空适用分销客户
    clearAllCustomers: function clearAllCustomers() {
      this.form.distributionCustomers = [];
      this.$message.info('已清空所有客户选择');
    },
    // 全选可使用场景
    selectAllScenarios: function selectAllScenarios() {
      if (this.availableProductTypeOptions.length > 0) {
        this.form.usableScenarios = this.availableProductTypeOptions.map(function (item) {
          return item.code;
        });
        this.$message.success("\u5DF2\u5168\u9009 ".concat(this.form.usableScenarios.length, " \u4E2A\u573A\u666F"));
      }
    },
    // 清空可使用场景
    clearAllScenarios: function clearAllScenarios() {
      this.form.usableScenarios = [];
      this.$message.info('已清空所有场景选择');
    }
  }
};